exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-outline[data-v-1a011f09]{border:2px solid;height:62px}@media screen and (min-width: 900px){.button-outline[data-v-1a011f09]{border:2px solid;min-width:220px}}.dark[data-v-1a011f09]{border:1px solid #2f2e3b}.dark[data-v-1a011f09]:hover,.dark[data-v-1a011f09]:focus{color:#fff;background:#000;border-color:#000}.light[data-v-1a011f09]:hover,.light[data-v-1a011f09]:focus{color:#000;background:#fff;border-color:#fff}\n", ""]);

// exports
